import { Link, makeStyles } from '@material-ui/core';
import { FunctionComponent, useContext, useMemo } from 'react';

import { WorkspaceAvatar } from 'src/components/WorkspaceAvatar';
import { PortalConfigContext } from 'src/context';
import { getPublicImageURL } from 'src/utils/ImageUtils';

interface PortalLogoProps {
  /** whether the logo is a preview logo */
  isPreviewLogo?: boolean;
  /** the URL of the preview logo */
  logoUrlPreview?: string;
}

const useStyles = makeStyles(() => ({
  root: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

const PortalLogo: FunctionComponent<PortalLogoProps> = (props) => {
  const { isPreviewLogo = false, logoUrlPreview } = props;
  const portalConfig = useContext(PortalConfigContext);
  const classes = useStyles();

  const logoPath = useMemo(() => {
    const url = isPreviewLogo
      ? logoUrlPreview
      : portalConfig.assets.logo.iconImageUrl;
    if (url) return getPublicImageURL(url);
    return '';
  }, [isPreviewLogo, logoUrlPreview, portalConfig]);

  return (
    <Link href="/" className={classes.root}>
      <div className="flex items-center">
        <WorkspaceAvatar
          size={isPreviewLogo ? 19 : 60}
          iconSrc={logoPath}
          workspaceName={portalConfig.name}
        />
      </div>
    </Link>
  );
};

export default PortalLogo;
